export const isScriptLoaded = (scriptSource) => {
  const scriptWithSource = document.querySelector(`script[src='${scriptSource}']`);
  return !!scriptWithSource;
};



// WEBPACK FOOTER //
// ./client/services/dom.js